/**
 * Allgemeine Utility-Methoden im Zusammenhang mit base.metamodel.json / Model,
 * welche für 3D-Modelle benutzt werden
 */
import {v3} from "oc-threejs/short3";
import Scenes from "oc-threejs/Scenes";
import Urls from "oc-commons/Urls";
import UniversalLoader from "oc-threejs/loader/UniversalLoader";
import ReplacingMaterialFactory from "oc-threejs/loader/ReplacingMaterialFactory";
import Commons from "oc-commons/Commons";
import Connector from "oc-interaction/connectors/Connector";

export default class Models {

    /**
     * Webdet die Model-Paramter Rotation, Scale, AutoCenter und Position auf ein 3D-Objekt an
     */
    static applyToObject3d(model, object3d) {

        if (model.Rotation) {
            object3d.quaternion.copy(model.Rotation);
        } else {
            object3d.quaternion.set(0, 0, 0, 1);
        }

        if (model.Scale) {
            object3d.scale.copy(model.Scale);
        } else {
            object3d.scale.set(1, 1, 1);
        }

        object3d.position.set(0, 0, 0);

        if (model.AutoCenter) {
            const gridPosition = model.GridPosition || v3(0.5, 0.5, 0.5);
            const box = Scenes.boundingBox(object3d);
            const c = box.grid(gridPosition).negate();
            object3d.position.add(c);
        }

        if (model.Position) {
            object3d.position.add(model.Position);
        }

        if (STAGE.settings.shadows.enabled) {
            Scenes.filter(object3d, o => o instanceof THREE.Mesh)
                .forEach(o => {
                    o.receiveShadow = true;
                    o.castShadow = true;
                });
        }
        return object3d;
    }

    static getConnectorsFromModelRelativeToObject(model, object3d){
        const connectors=[];
        if (model.Connector && Array.isArray(model.Connector)) {
            model.Connector.forEach(config => {
                const connector = new Connector([config.connectorname, config.connectortype, config.strengthFactor]);
                const connectorOptions = {
                    position: v3(object3d.posbox.grid(config.position_relativ)).add(config.position_absolut),
                    quaternion: config.rotation
                };
                connectors.push(connector);
                connector.setConnectorOptions(connectorOptions);
            });
        }
        return connectors;
    }

    /**
     * @returns {Promise}
     */
    static loadModelPromise(model) {
        const url = Urls.isAbsolute(model.Path) ? model.Path : APP.settings.wkfgContentBaseUrl + model.Path;
        const materialFactory = new ReplacingMaterialFactory(model.MaterialMap, UniversalLoader.getMaterialFactory());
        const cacheKey = Commons.cacheKey(model.Path, model.MaterialMap);
        return UniversalLoader.loadModelPromise(url, materialFactory, cacheKey)
            .then(object => Models.applyToObject3d(model, object));
    }

}
